const widthMediaQueryBreakpoints = {
  xxsm: 400,
  xsm: 768,
  sm: 1023,
  md: 1280,
  lg: 1599,
  xl: Number.MAX_SAFE_INTEGER,
  isXxsm: '(max-width: 400px)',
  isXsm: '(max-width: 768px)',
  isSm: '(min-width: 769px) and (max-width: 1023px)',
  isMd: '(min-width: 1024px) and (max-width: 1280px)',
  isLg: '(min-width: 1281px) and (max-width: 1599px)',
  isXl: '(min-width: 1600px)',
} as const;

const heightMediaQueryBreakpoints = {
  xsm: 480,
  sm: 600,
  md: 780,
  lg: 900,
  xl: 1080,
  xxl: 1440,
} as const;

const aspectRatioMediaQueryBreakpoints = {
  ultraWide: 'uw',
  standardWide: 'sw',
  isUltraWide: '(aspect-ratio >= 16 / 9) and (max-height: 780px)',
  isMobileLandscape: '(aspect-ratio >= 16 / 9 )',
  isSquare: '(max-aspect-ratio: 1/1)',
  isPortrait: '(max-aspect-ratio: 3/4)',
  isMobilePortrait: '(max-aspect-ratio: 2/3)',
} as const;

const MediaQueryBreakpoints = {
  ...widthMediaQueryBreakpoints,
  ...aspectRatioMediaQueryBreakpoints,
  height: heightMediaQueryBreakpoints,
  mobileMenuBreakpoint: 1180,
} as const;

export default MediaQueryBreakpoints;
